import React, { ComponentProps } from 'react';
import { ImageTypes, ProfileImage } from '../../../types/api/ImageType';
import { useBlockContext, useRefreshBlock } from '../../../_lib/BlockFetcher';
import { useSonTranslation } from '../../../translation/useSonTranslation';

import { asFetchableView } from '../../../_lib/ViewFetcher';
import { ImageUploadForm } from '../../../_lib/components/ImageUpload/ImageUploadForm';
import { HiddenParam, SonForm, TextParam } from '../../../_lib/Form2';
import { NestedParam } from '../../../_lib/Form2/types/NestedParam';
import { ImageFileParam } from '../../../_lib/Form2/types/FileUploadParam';

type PortalLogoEditProps = {
  image: ProfileImage;
  viewportSwitch: boolean;
  form: SonForm<
    NestedParam<
      'imageuploadparams',
      'imageupload',
      | ImageFileParam<'image'>
      | HiddenParam<'width'>
      | HiddenParam<'height'>
      | HiddenParam<'y'>
      | HiddenParam<'x'>
      | TextParam<'alt'>
      | TextParam<'copyright'>
      | TextParam<'caption'>
    >
  >;
};

export function PortalLogoEdit({ image, form, viewportSwitch }: PortalLogoEditProps) {
  const { uuid } = useBlockContext();
  const { refresh } = useRefreshBlock();
  const { t } = useSonTranslation('PortalLogo');

  return (
    <ImageUploadForm
      imageDescriptionName={t('imageDescriptionName')}
      cropping={false}
      viewportSwitch={viewportSwitch}
      form={form}
      imageType={ImageTypes.portalLogo}
      formId="portal-logo-image-upload-form"
      uuid={uuid}
      initialImage={image}
      refresh={refresh}
      additionalDescription={t('additionalDescription')}
    />
  );
}

export const PortalLogoEditView = asFetchableView(PortalLogoEdit);
export type PortalLogoEditView = ComponentProps<typeof PortalLogoEditView>;
